import React, { useEffect, useState } from 'react';
import { ErrorMessage, FieldProps, useField } from 'formik';
import { memo } from 'react';
import Select from 'react-select';
import { BiErrorCircle } from 'react-icons/bi';

interface Option {
  label: string;
  value: string;
}

interface CustomSelectProps extends FieldProps {
  options: any;
  isMulti?: boolean;
  className?: string;
  placeholder?: string;
  label?: string;
  defaultValue?: string;
}

export const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    border: state?.isFocused ? '1px solid #CACFE3' : '1px solid #CACFE3',
    '&:hover': {
      border: '1px solid #CACFE3',
    },
    padding: '6px 16px',
    borderRadius: 12,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: '#16161C',
  }),
  menu: (provided: any) => ({
    ...provided,
    minHeight: '100px',
    overflowY: 'auto',
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#4062FF' : '#fff',
    color: state.isFocused ? 'white' : 'black',
    '&:hover': {
      backgroundColor: '#4062FF',
      color: 'white',
    },
  }),

  multiValue: (styles: any, { data }: { data: any }) => {
    return {
      ...styles,
      backgroundColor: 'white',
      color: '#4062FF',
      border: '1px solid #4062FF',
      borderRadius: '8px',
    };
  },
  multiValueLabel: (styles: any, { data }: { data: any }) => ({
    ...styles,
    color: data.color,
  }),
  multiValueRemove: (styles: any, { data }: { data: any }) => ({
    ...styles,
    color: data.color,
    marginTop: '2px',
    ':hover': {
      backgroundColor: data.color,
      color: '#4062FF',
    },
  }),
};

export const LabelCustomSelect = ({
  className,
  placeholder,
  field,
  form,
  options,
  label,
  isMulti = false,
  defaultValue,
}: CustomSelectProps) => {
  const selectOptions = options
    ? options?.map((item: { name: string; id: string }) => {
        return {
          label: item?.name,
          value: item?.id,
        };
      })
    : [];

  const onChange = (selectOptions: any) => {
    form.setFieldValue(
      field.name,
      isMulti
        ? (selectOptions as Option[]).map((item: Option) => item.value)
        : (selectOptions as Option).value
    );
  };
  //   const getValue = () => {
  //     if (selectOptions) {
  //       return isMulti
  //         ? selectOptions.filter(
  //             (option: any) =>
  //               field.value && field.value.indexOf(option.value) >= 0
  //           )
  //         : selectOptions.find(
  //             (option: any) =>
  //               field.value && option.value + '' === field.value + ''
  //           );
  //     } else {
  //       return isMulti ? [] : ('' as any);
  //     }
  //   };

  return (
    <>
      <div>
        <label
          className={`text-text-black  text-md mb-4 block z-[1] relative `}
          htmlFor={field.name}
        >
          {label}
          <Select
            className={className}
            name={field.name}
            isClearable={true}
            onChange={onChange}
            styles={customStyles}
            placeholder={placeholder}
            defaultValue={defaultValue}
            options={selectOptions}
            isMulti={isMulti}
            classNamePrefix="react-select "
            menuPortalTarget={document.body}
          />
        </label>
        <div className="relative">
          <BiErrorCircle
            size={17}
            color="#fff"
            className="absolute top-2 mx-2 z-0"
          />

          <ErrorMessage
            component="div"
            name={field.name}
            className=" bg-warning  bg-opacity-80 text-pure-white mt-1 text-xs inline-block px-7 py-1 rounded-sm"
          />
        </div>
      </div>
    </>
  );
};

export default memo(LabelCustomSelect);
